import type { DeletedOverlay, ListResult, Overlay, OverlayInit, SearchableFilter } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'
import type { RequestOptions } from 'common/network/request-options'
import { OverlaysRequestParams, singleSortQueryFromPaginatedRequestParams } from '../nm-types'

export class OverlaysApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  listOverlays(
    { filter, name, ...params }: OverlaysRequestParams,
    options?: Pick<RequestOptions, 'signal'>,
  ): Promise<ListResult<Overlay>> {
    const searchFilter: any = {}

    if (name) {
      searchFilter.searchName = name
    }

    if (filter) {
      searchFilter.searchAny = filter
    }

    const query = singleSortQueryFromPaginatedRequestParams<SearchableFilter, string>({
      filter: searchFilter,
      paginatedRequestParams: params,
    })

    return this.edgeClient.listOverlays(query, options)
  }

  getOverlay(id: string): Promise<Overlay> {
    return this.edgeClient.getOverlay(id)
  }

  createOverlay(overlay: OverlayInit): Promise<Overlay> {
    return this.edgeClient.createOverlay(overlay)
  }

  updateOverlay(overlay: Overlay): Promise<Overlay> {
    return this.edgeClient.updateOverlay(overlay.id, overlay)
  }

  deleteOverlay(id: string): Promise<DeletedOverlay> {
    return this.edgeClient.deleteOverlay(id)
  }
}
